const xvnode = (ss, cfg, gr, nd, pg, subj) => {
  const { div, a, span } = cfg.h(pg, nd)
  const title = subj.title || subj.label
  const label = subj.label
  const note = subj.note
  const href = subj.href

  return (
    div('.:ui-root', [
      span('.:ui-note', note),
      a('.:ui-link', { href, title }, [
        span('.:ui-link-label-primary', label)
      ])
    ])
  )
}

export default {
  type: 'uiarticleTileOneLine',
  xvnode
}
